import { useTranslation } from 'react-i18next';

const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string) => {
  event.dataTransfer.setData('application/reactflow', nodeType);
  event.dataTransfer.effectAllowed = 'move';
};

const Sidebar = () => {
  const { t } = useTranslation();
  return (
    <aside id="flow-sidebar" className="border-r-2 border-gray-200 p-4 text-sm bg-gray-100 w-64 h-full">
      <div className="mb-4 font-bold">{t('dragNodesInstruction')}</div>
      <div
        className="bg-white p-3 border-2 border-blue-500 rounded-md cursor-grab mb-4"
        onDragStart={(event) => onDragStart(event, 'message')}
        draggable
      >
        {t('messageNode')}
      </div>
      {/* <div
        className="bg-white p-3 border-2 border-green-500 rounded-md cursor-grab mb-4"
        onDragStart={(event) => onDragStart(event, 'ai')}
        draggable
      >
        AI Node
      </div> */}
      <div
        className="bg-white p-3 border-2 border-yellow-500 rounded-md cursor-grab mb-4"
        onDragStart={(event) => onDragStart(event, 'menu')}
        draggable
      >
        {t('menuNode')}
      </div>
      <div
        className="bg-white p-3 border-2 border-red-500 rounded-md cursor-grab"
        onDragStart={(event) => onDragStart(event, 'live-agent')}
        draggable
      >
        {t('transferToLiveAgent')}
      </div>
      <div
        className="bg-white p-3 border-2 border-gray-500 rounded-md cursor-grab mt-4"
        onDragStart={(event) => onDragStart(event, 'end')}
        draggable
      >
        {t('endFlow')}
      </div>
    </aside>
  );
};

export default Sidebar;
